export default __webpack_public_path__ + "1677074bd2bb3f05ec50046dbda8e843.png";